import axios from "axios";

const TOKEN_KEY = "pnl_token";
const COMPANY_KEY = "pnl_company";
export const DEACTIVATED = "Your company account is deactivated. Contact support.";
export const REVOKED = "Your access has been revoked. Contact your administrator.";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const getCompanyId = () => localStorage.getItem(COMPANY_KEY);
export const setCompanyId = (id) => (id ? localStorage.setItem(COMPANY_KEY, id) : localStorage.removeItem(COMPANY_KEY));

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const company = getCompanyId();
  if (company && !config.headers["X-Company-Id"]) config.headers["X-Company-Id"] = company;
  return config;
});

const toLogin = (notice) => {
  const back = localStorage.getItem("pnl_admin_token");
  if (back) {
    // impersonation session ended / expired: return to the super admin's own session
    localStorage.removeItem("pnl_admin_token");
    setToken(back);
    setCompanyId(localStorage.getItem("pnl_admin_company") || null);
    localStorage.removeItem("pnl_admin_company");
    window.location.assign("/admin/users");
    return;
  }
  clearToken();
  if (notice) sessionStorage.setItem("login_notice", notice);
  const slug = localStorage.getItem("pnl_login_slug");
  const target = slug ? `/login/${slug}` : "/login";
  if (!window.location.pathname.startsWith("/login")) window.location.assign(target);
};

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const isLogin = err.config?.url?.includes("/auth/login");
    if (err.response?.status === 401 && !isLogin) toLogin();
    const detail = err.response?.data?.detail;
    if (err.response?.status === 403 && [DEACTIVATED, REVOKED].includes(detail) && !isLogin) toLogin(detail);
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export default api;
